import React from 'react'
import Discounted_products from './Discounted_products';
import Container from '../../Container/Container'

function SpecialSaleProducts() {
    return (
        <>
            <Container class1='container-fluid style-sec my-2'>
                <div className="rounded">
                    <div className="col-12 ">
                        <h4>
                            محصولات فروش ویژه
                        </h4>
                    </div>
                    <Discounted_products />
                </div>
            </Container>
        </>
    )
}

export default SpecialSaleProducts